module.exports = __webpack_public_path__ + "img/IMG_2178.4283d959.jpg";